import { fetchHasPremium } from 'shared/api/fetchPremiumData';

export const getPremium = async (): Promise<boolean> => {
  const eqPremium = await fetchHasPremium('eq');
  const myEmotionsPremium = await fetchHasPremium('my_emotions');

  return eqPremium || myEmotionsPremium;
};
